import styles from "./IncludedGuarantees.module.scss";
import classNames from "classnames/bind";
import { ListWithIcon } from "@/components/DeliveryAndGuaranteesMessage/components/ListWithIcon";

const cx = classNames.bind(styles);

type Props = {
  /**
   * A list of guarantees.
   */
  guarantees?: { id: string; title: string }[];
};

export const IncludedGuarantees = ({ guarantees }: Props) => {
  if (!guarantees || guarantees.length === 0) {
    return null;
  }

  return (
    <ul
      data-testid="product:included-guarantees:list"
      className={cx(styles.list, {
        mobileGalleryExperience: false, // TODO: !!mobileGalleryExperience,
      })}
    >
      {guarantees.map(({ id, title }) => {
        return (
          <ListWithIcon
            key={`guarantee-${id}`}
            cssClasses={styles.item}
            textMessage={title}
            dataTestId="product:included-guarantees:title"
            iconType="guarantee"
          />
        );
      })}
    </ul>
  );
};
